angular.module('controllers', [])
    .controller('mainController', ['$scope', '$rootScope', 'Crud', '$mdDialog', '$mdSidenav', '$timeout', '$route', '$routeParams', '$location', 'Fullscreen', '$interval',
        function ($scope, $rootScope, Crud, $mdDialog, $mdSidenav, $timeout, $route, $routeParams, $location, Fullscreen,  $interval) {

            $rootScope.pathImages = '/images/app';
            $scope.location = $location.path();
            if (!angular.isUndefined($route.current)) {
                $scope.currentRoute = $route.current.$$route.originalPath;
            }
                        
            $scope.$watch('$viewContentLoaded', function() { 
                        $timeout(function() {
                             var sidebar = angular.element(document.querySelector('#sidebar'));
                             if ($('#sidebar').length <= 0) {
                                  $('.main').css({'margin-left': 10 + 'px'});
                                }
                     },500);   
                });

        /* login video */
        /*var video = document.getElementById("video-login"); 
         if (!angular.isUndefined(video) && video != null & video != 'null') {
                 video.addEventListener('ended', (event) => {
                      video.load();
                });
        }
        $scope.playPause = function (ev) { 
             var video = document.getElementById("video-login"); 
             if (!angular.isUndefined(video) && video != null & video != 'null') {
                        var videoButton = document.getElementById("video-button"); 
                        angular.element(videoButton.querySelector('i')).toggleClass('fa-play fa-pause');
          
                          if (video.paused) {
                            video.play(); 
                          } else {
                            video.pause(); 
                          }
             }
        } */

            /*on map*/
            $scope.fullSize = function (ev) {
                var widthRightBar = $('#rightbar').width();
                angular.element(document.querySelector('#sidebar')).toggleClass('max-size ');
                if (angular.element(document.querySelector('#sidebar')).hasClass('max-size')) {
                    angular.element(document.querySelector('#sidebar-resizer')).css('left', '0');
                    angular.element(document.querySelector('#sidebar')).css('width', 0);
                } else {
                    angular.element(document.querySelector('#sidebar')).css('width', 250);
                    angular.element(document.querySelector('#sidebar-resizer')).css('left', '250px');
                }
            }

            /* fullscreen */
            document.addEventListener('webkitfullscreenchange', endFullscreen, false);
            document.addEventListener('mozfullscreenchange', endFullscreen, false);
            document.addEventListener('fullscreenchange', endFullscreen, false);
            document.addEventListener('MSFullscreenChange', endFullscreen, false);
            function endFullscreen()
            {
                //if (Fullscreen.isEnabled() == false) {
                    $('.main-toolbar, #sidebar, #rightbar, #footer, #sidebar-resizer, #rightbar-resizer, .loader').removeClass('hide');
                    var id='card';
                    $('#' + id + ' table tr td:last-child, #' + id + ' table tr th:last-child, #' + id + ' table tr td:first-child, #' + id + ' table tr th:first-child').removeClass('hide');

                    var idc='card-order';
                    $('#' + idc + ' table tr td:last-child, #' + idc + ' table tr th:last-child, #' + idc + ' table tr td:first-child, #' + idc + ' table tr th:first-child').removeClass('hide');

                    $('#card').css('width', 'auto');

            }
            $scope.goFullscreen = function (param) {
                if (Fullscreen.isEnabled()) {
                    Fullscreen.cancel();Fullscreen.cancel();
                } else {
                    $('.main-toolbar, #sidebar, #rightbar, #footer, #sidebar-resizer, #rightbar-resizer').addClass('hide');
                    $('#content').css('width', '100%');
                    Fullscreen.all();
                }
            };
            $scope.goPreview = function (id) {
                if(!angular.isUndefined(id)) {
                    if (Fullscreen.isEnabled()) {
                        Fullscreen.cancel();
                    } else { 
                        //$('#' + id + ' table tr td:last-child, #' + id + ' table tr th:last-child, #' + id + ' table tr td:first-child, #' + id + ' table tr th:first-child',).addClass('hide');
                       // $('.main-toolbar, #sidebar, #rightbar, #footer, #sidebar-resizer, #rightbar-resizer, .loader').addClass('hide');
                       // $('#' + id).css('width', '100%');
                        Fullscreen.enable(document.querySelector('#' + id));
                    }
                }
            }
            /* end fullscreen */

            /* change size font */
            $rootScope.changeFont = function (ev, style) {
                $rootScope.font = style;
                if(angular.isUndefined($rootScope.size)) {
                    $rootScope.size = 11;
                }
                if(style == 'increase') {
                    $rootScope.size = $rootScope.size + 1;
                } else {
                    if($rootScope.size > 1) {
                        $rootScope.size = $rootScope.size - 1;
                    }
                }
                $rootScope.fontSize = {'font-size':$rootScope.size+'px'};
            }
            /* end change font */

            /* change settings */
            $rootScope.changeTheme = function (ev, color) {
                $rootScope.theme = color;
            }
            $rootScope.changeModeAction = function (ev, modAction) {
                $rootScope.mode_action = modAction;
            }
            /* end change settings */

            /* go history */
            $scope.goBack = function () {
                history.back();
            }
            $scope.goForward = function () {
                history.forward();
            }
            $scope.refresh = function () {
                location.reload();
                //$route.reload();
                if(document.getElementById("map-route")) {
                    document.getElementById("map-route").outerHTML = "";
                }
            }
            /* end go history */

            /* settings */
            $scope.publicImagesPath = '/images';
            $scope.currentDate = new Date();
            /* end settings */

            /* login user */
            $scope.user = {};
            $scope.login = function () {
                var post = $scope.user;
                Crud.post('form-urlencoded', post, '/post-login')
                    .success(function (data) {
                        $scope.errors = {};
                        if(data.errors) {
                            $scope.errors_message = data.errors;
                        } else {
                            localStorage.setItem('log', 1);

                            if(data.user.roles.indexOf('Dispecerat') > -1) {
                                window.location.href = '/order/getOrder';
                            }
                            else if(data.user.roles.indexOf('Bucatar') > -1) {
                                if(!angular.isUndefined(data.kitchens)) {
                                    window.location.href = '/order/view/' + data.kitchens['id'];
                                } else {
                                    window.location.href = '/';
                                }
                            }
                            else if(data.user.roles.indexOf('Distributie') > -1) {
                                window.location.href = '/slot';
                            }
                            else if(data.user.roles.indexOf('Ospatar') > -1) {
                                window.location.href = '/restaurant/serveRestaurant';
                            }
                            else{
                                window.location.href = '/';
                            }
                            //$rootScope.auth = true;
                            $rootScope.session.user = data.user;
                            $rootScope.permissions = data.permissions;

                            $rootScope.init();

                        }
                    })
                    .error(function (data) {
                        $scope.errors_message = '';
                        $scope.errors = data.errors;
                    });
            };
            /* end login user */

            /* logout user */
            $scope.logout = function () {
                Crud.get('/logout')
                    .success(function (data) {
                        //$rootScope.auth = false;
                        $rootScope.session.user = '';
                        $scope.user = {};
                        localStorage.clear();
                        //$location.path('/');
                        window.location.href = '/';
                    });
            };
            /* logout user */

            $rootScope.getBreadcrumbs = function () {

                 if(!angular.isUndefined($rootScope.permissions) ){
                        if($rootScope.permissions =='all' || $rootScope.permissions['menu.breadcrumbs']) {
                                    var post = {};
                                    post['state'] = $location.path();
                                    post['route'] = 'breadcrumbs';
                                    post['user'] = $rootScope.session.user;
                                    Crud.post('form-urlencoded', post, '/menu/breadcrumbs')
                                        .success(function (data) {
                                            $scope.breadcrumbs = data;
                                        })
                                        .error(function (data) {
                                        });
                                }
                           
                }
                
                
                
                
                
            };

            /* init app */
            $rootScope.init = function () {

                //if(!angular.isUndefined($rootScope.session.user)) {
                $rootScope.initMenu();

                /* if(!angular.isUndefined($rootScope.detailUser)) {
                 $rootScope.detailUser();
                 }
                 if(!angular.isUndefined($rootScope.detailClient)) {
                 $rootScope.detailClient();
                 }*/
            }

            /* side menu*/
            $scope.openMenu = function () {
                $mdSidenav('left').toggle();
            };
            $scope.sections = [];
            /* end side menu */

            $rootScope.initMenu = function () {
                if(!angular.isUndefined($rootScope.permissions) ){
                        if($rootScope.permissions =='all' || $rootScope.permissions['menu.hierarchicalmenu']) {
                            Crud.get('/menu/hierarchicalMenu')
                                .success(function (data) {
                                    $scope.sections = data.menus;
                                });
                        }
                       
                }
            }

            /* remove expanded menu if click outside */
            $(document).click(function(e) {
                if( ! $(e.target).closest('.menu-toggle-list,.md-button-toggle').length ) {
                    $('.menu-toggle-list').hide();
                    $('.md-toggle-icon').removeClass('toggled');
                    self.openedSection = null;
                }
            });
            /* end remove expanded menu if click outside */

            var self;
            return self = {
                sections: $scope.sections,
                toggleSelectSection: function (section, parentSection) {
                    //self.openedSection = (self.openedSection === section ? null : section);
                    /*console.log('open=   ',self.openedSection);
                    console.log('section=   ',section);
                    console.log('parent=   ',parentSection);*/
                    if(self.openedSection === section) {
                        self.openedSection = null;
                        $('.menu-toggle-list').hide();
                    } else {
                        $('.menu-toggle-list').show();
                        if(section !== parentSection ) {
                            var sectionId = section.id;
                            var parentId = parentSection.id;
                            //$('ul ul .'+ parentId).addClass('ng-hide');
                            $('#docs-menu-'+ sectionId).toggleClass('ng-hide ');
                            $('#docs-menu-button-'+ sectionId+' i').toggleClass('toggled ');
                        } else {
                            self.openedSection = section;
                        }
                    }
                },
                isSectionSelected: function (section, parentSection) {
                    //return self.openedSection === section;
                    /*if(!angular.isUndefined(parentSection) && section.id != parentSection.id && parentSection.menu_parent_id  == 0) {
                        return true;
                    } else {*/
                        if( self.openedSection === section) { 
                             return true;
                        } else {
                            return false;
                        }
                    //}
                },
                isOpen: function (section, parentSection) {
                    return self.isSectionSelected(section, parentSection);
                },
                toggleOpen: function (section, parentSection) {
                    self.toggleSelectSection(section, parentSection);
                },
                 checkActive: function (section, parentSection) {
                     if (angular.element(document.querySelector('#sidebar')).width() >= 249) {
                            return true;
                     }
                }
            };
            /* end init app */

        }])

    .run(['$templateCache', function ($templateCache) {
        $templateCache.put('partials/menu-toggle.tmpl.html',
            '<md-button class="md-button-toggle"\n' +
            '  ng-click="toggle($parent)"\n' +
            '  aria-controls="docs-menu-{{section.id}}"\n' +
            '  id="docs-menu-button-{{section.id}}"\n' +
            '  aria-expanded="{{isOpen($parent.$parent)}}" ng-class="{\'active\' : isOpen($parent.$parent) && checkActive($parent.$parent) }">\n' +
            '  <div class="toggle-div"><i class="fa {{section.menu_icon}} icon" aria-hidden="true"></i>'+
            '  {{section.menu_title}}\n' +
            '  <i aria-hidden="true" class="pull-right fa fa-chevron-down md-toggle-icon"\n' +
            '  ng-class="{\'toggled\' : isOpen($parent.$parent)}"></i></div>\n' +
            '</md-button>\n' +

            '<ul ng-if="section.menu_parent_id != 0" ng-show="isOpen($parent.$parent)" id="docs-menu-{{section.id}}" class="active">\n' +
            '  <li ng-repeat="page in section.pages">\n' +
            '    <menu-link section="page" ng-if="page.menu_type === \'link\'" class="link"></menu-link>\n' +
            '    <menu-toggle section="page" ng-if="page.menu_type === \'toggle\'" class="toggle"></menu-toggle>\n' +
            '  </li>\n' +
            '</ul>\n' +

            '<ul ng-if="section.menu_parent_id == 0" ng-show="isOpen($parent.$parent)" id="docs-menu-{{section.id}}" class="menu-toggle-list">' +
            '  <li ng-repeat="page in section.pages">' +
            '    <menu-link section="page" ng-if="page.menu_type === \'link\'" class="link"></menu-link>\n' +
            '    <menu-toggle section="page" ng-if="page.menu_type === \'toggle\'" class="toggle"></menu-toggle>\n' +
            '  </li>' +
            '</ul>' +

            '');
    }])
    .directive('menuToggle', [function () {
        return {
            scope: {
                section: '='
            },
            templateUrl: 'partials/menu-toggle.tmpl.html',
            link: function (scope, element) {
                var controller = element.parent().controller();
                scope.isOpen = function (parent) {
                    return controller.isOpen(scope.section, parent.section);
                };
                 scope.checkActive = function (parent) {
                    return controller.checkActive(scope.section, parent.section);
                };
                scope.toggle = function (parent) {
                    controller.toggleOpen(scope.section, parent.section);
                };

                var parentNode = element[0].parentNode.parentNode.parentNode;
                if (parentNode.classList.contains('parent-list-item')) {
                    var heading = parentNode.querySelector('h2');
                    element[0].firstChild.setAttribute('aria-describedby', heading.id);
                }
            }
        };
    }])
    .run(['$templateCache', function ($templateCache) {
        $templateCache.put('partials/menu-link.tmpl.html',
            '<md-button ng-if="section.menu_title" ui-sref-active="active" \n' +
            '  href="{{section.menu_state}}"  ui-sref="{{section.menu_state}}" ng-click="focusSection()"><i class="{{section.icon}}"></i>\n' +
            '  {{section.menu_title}}\n' +
            '  <span class="md-visually-hidden "\n' +
            '    ng-if="isSelected()">\n' +
            '    current page\n' +
            '  </span>\n' +
            '</md-button>\n' +
            '');

    }])
    .directive('menuLink', function () {
        return {
            scope: {
                section: '='
            },
            templateUrl: 'partials/menu-link.tmpl.html',
            link: function ($scope, $element) {
                var controller = $element.parent().controller();
                $scope.focusSection = function () {
                    controller.autoFocusContent = true;
                };
            }
        };
    });
